<form [formGroup]="fourthQuestionFormGroup" class="wizard-item">
    <div class="row">
        <div class="col-12 wizard-question">
            <span *ngIf="DICTIONARY_REIMBURSEMENT_TYPE.PARTIAL_REIMBURSEMENT?.id === contractModificationRequest.dictionaryReimbursementTypeId">
                {{'contractModifications.wizard.questions.WhatIsThePurposeOfThisReimbursement' | translate}}
            </span>

            <span *ngIf="DICTIONARY_CONTRACT_MODIFICATION_TYPE.INSTALLMENT_DEFERRAL?.id === contractModificationRequest.dictionaryModificationTypeId">
                {{'contractModifications.wizard.questions.WhatIsThePurposeOfThisRequest' | translate}}
            </span>
        </div>
    </div>
    <ng-container *ngFor="let purpose of contractModificationPurposeDatasource; let purposeIndex = index">
        <div class="row justify-content-center">
            <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4 radio-container">
                <input class="radio-input" type="radio" kendoRadioButton size="large"
                    id="purpose-{{purpose.id}}"
                    name="answear"
                    [value]="purpose.id"
                    [(ngModel)]="fourthQuestionFormGroup.value.answear"
                    formControlName="answear"
                    required
                >
                <label class="radio-label" for="purpose-{{purpose.id}}">
                    {{purpose.value}}
                </label>
            </div>
        </div>
    </ng-container>

    <div class="d-flex justify-content-center mt-4">
            <button
                class="btn primary-btn"
                [disabled]="fourthQuestionFormGroup.value.answear === null"
                (click)="nextStepHandler(wizardStepsEnum.ContractModification_RequestPurpose, fourthQuestionFormGroup.value.answear)"
            >
                {{'contractModifications.wizard.continueBtn' | translate}}
            </button>
        </div>
</form>
